// import { initHeader } from './header';
import { onReady, findOnPage } from 'ok-tools';


import { initMainMenu } from './src/main-menu';
import { initHomehero } from './src/homehero';
import { initFreeCoursePopup, showFreeCoursePopup } from './src/free-course-popup';
import { initHomeMethod } from './src/home-method';
import { initHomeOnline } from './src/home-online';
import { initHomeReferences } from './src/home-references';
import { initHomeSelect } from './src/home-select';
import { initHomeFaces } from './src/home-faces';
import { initHomeFootButtons } from './src/home-foot-buttons';

class OJNew {
	public mainMenu = initMainMenu;
	public homehero = initHomehero;
	public freeCoursePopup = initFreeCoursePopup;
	public showFreeCoursePopup = showFreeCoursePopup;
	public homeOnline = initHomeOnline;
	public homeMethod = initHomeMethod;
	public homeReferences = initHomeReferences;
	public homeSelect = initHomeSelect;
	public homeFaces = initHomeFaces;
	public homeFootButtons = initHomeFootButtons;

}


window['OJNew'] = new OJNew();
// @ts-ignore
window['$'] = onReady;

// @ts-ignore
window['$$'] = findOnPage;

